// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37805591","239":"6134b57c","453":"2c288793","732":"d2755828"}[chunkId] + ".chunk.js";
};